/**
 * 从 FSM orderRoomPageList 单条房单行提取**当日预测可计入的一晚房费**。
 *
 * 注意：列表里的 totalPrice / orderAmount 多为**整单/全程**金额，不能直接相加作为「当日预测收入」，
 * 否则会把多晚房费算进去（数值会远大于 (在住+预抵)×ADR）。
 * 口径：优先用单价类字段；总价类按间夜数摊成「一晚」再汇总。
 */
function num(v) {
    if (v == null || v === "")
        return null;
    var x = typeof v === "number" ? v : Number(v);
    return Number.isFinite(x) ? x : null;
}
function round2(v) {
    return Math.round(v * 100) / 100;
}
/** 房单全程间夜数（至少 1），用于把「总价」摊到「一晚」 */
function rowNights(r) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var rn = (_f = (_e = (_d = (_c = (_b = (_a = num(r.roomNight)) !== null && _a !== void 0 ? _a : num(r.room_night)) !== null && _b !== void 0 ? _b : num(r.reserveRoomNight)) !== null && _c !== void 0 ? _c : num(r.reserve_room_night)) !== null && _d !== void 0 ? _d : num(r.nights)) !== null && _e !== void 0 ? _e : num(r.dayNum)) !== null && _f !== void 0 ? _f : num(r.roomQuantity);
    if (rn != null && rn >= 0.5) {
        return Math.max(1, Math.ceil(rn));
    }
    var cin = Number((_k = (_j = (_h = (_g = r.planCheckinDate) !== null && _g !== void 0 ? _g : r.plan_checkin_date) !== null && _h !== void 0 ? _h : r.planCheckinTime) !== null && _j !== void 0 ? _j : r.plan_checkin_time) !== null && _k !== void 0 ? _k : 0);
    var cout = Number((_p = (_o = (_m = (_l = r.planCheckoutDate) !== null && _l !== void 0 ? _l : r.plan_checkout_date) !== null && _m !== void 0 ? _m : r.planCheckoutTime) !== null && _o !== void 0 ? _o : r.plan_checkout_time) !== null && _p !== void 0 ? _p : 0);
    if (Number.isFinite(cin) && Number.isFinite(cout) && cout > cin) {
        var sec = cout - cin;
        var days = sec / 86400;
        if (days >= 1)
            return Math.max(1, Math.round(days));
    }
    return 1;
}
/**
 * 单条房单：可视为「当晚」房费的一晚金额。
 */
export function rowOrderRoomPrice(r) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    var nights = rowNights(r);
    // ① 单价类（多为每晚房价 / 房费单价）
    var unit = (_k = (_j = (_h = (_g = (_f = (_e = (_d = (_c = (_b = (_a = num(r.roomPrice)) !== null && _a !== void 0 ? _a : num(r.room_price)) !== null && _b !== void 0 ? _b : num(r.price)) !== null && _c !== void 0 ? _c : num(r.unitPrice)) !== null && _d !== void 0 ? _d : num(r.unit_price)) !== null && _e !== void 0 ? _e : num(r.origPrice)) !== null && _f !== void 0 ? _f : num(r.orig_price)) !== null && _g !== void 0 ? _g : num(r.listPrice)) !== null && _h !== void 0 ? _h : num(r.list_price)) !== null && _j !== void 0 ? _j : num(r.avgPrice)) !== null && _k !== void 0 ? _k : num(r.avg_price);
    if (unit != null && unit > 0) {
        return round2(unit);
    }
    // ② 总价类：按间夜摊薄到一晚
    var totalLike = (_q = (_p = (_o = (_m = (_l = num(r.totalPrice)) !== null && _l !== void 0 ? _l : num(r.total_price)) !== null && _m !== void 0 ? _m : num(r.payableAmount)) !== null && _o !== void 0 ? _o : num(r.payable_amount)) !== null && _p !== void 0 ? _p : num(r.orderAmount)) !== null && _q !== void 0 ? _q : num(r.order_amount);
    if (totalLike != null && totalLike > 0) {
        return round2(totalLike / nights);
    }
    // ③ 房费+杂费（多已为已发生额，不再除间夜）
    var roomPart = (_w = (_v = (_u = (_t = (_s = (_r = num(r.roomFee)) !== null && _r !== void 0 ? _r : num(r.room_fee)) !== null && _s !== void 0 ? _s : num(r.roomConsumption)) !== null && _t !== void 0 ? _t : num(r.room_consumption)) !== null && _u !== void 0 ? _u : num(r.roomTotalPrice)) !== null && _v !== void 0 ? _v : num(r.room_total_price)) !== null && _w !== void 0 ? _w : 0;
    var other = (_y = (_x = num(r.otherConsumption)) !== null && _x !== void 0 ? _x : num(r.other_consumption)) !== null && _y !== void 0 ? _y : 0;
    var s = roomPart + other;
    if (s > 0) {
        return round2(s);
    }
    return 0;
}
export function sumOrderRoomListPrices(list) {
    if (!(list === null || list === void 0 ? void 0 : list.length))
        return 0;
    var s = 0;
    for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
        var r = list_1[_i];
        s += rowOrderRoomPrice(r);
    }
    return round2(s);
}
